<script>
import Section from '../../components/PageSection';
import Card from '../../components/projets/Card';
// import Separatif from '../../components/Separatif';
import Ajouter from '../../components/PageForm';
import Modale from '../../components/Modale';
import ModaleYesNo from '../../components/ModalYesNo';
import Spinner from '../../components/Spinner.vue';

export default {
  name: 'List',
  components: {
    Section,
    Card,
    // Separatif,
    Ajouter,
    Modale,
    ModaleYesNo,
    Spinner,
  },
  data(){
    return{
      projets: null,
      overs: null,
      isModalVisible: false,
      modalProject: {},
    }
  },
  mounted(){
    //Chargement des projets en cours
    this.$axios.get('projets/actives/' + this.$store.state.auth.currentAgence._id)
      .then(response => (this.projets = response.data));

    //Chargement des projets terminés
    this.$axios.get('projets/overs/' + this.$store.state.auth.currentAgence._id)
      .then(response => (this.overs = response.data));
  },
  methods: {
    addProjet(payload){
      if (payload){
        let projet = {
        name: payload[0],
        localisation: payload[1],
        agenceId: this.$store.state.auth.currentAgence._id,
        active: true,
        deleted: false,
        date: Date.now(),
      }

      //Envoi à la BDD
      this.$axios.post('projets', projet)
          .then(response => {
            //J'ajoute le nouveau projet dans this.projets pour qu'il s'affiche dans le DOM.
            //Je lui ajoute la propriété _id communiquée dans la response du server pour que je puisse immédiatement manipuler le nouvel objet du DOM (le supprimer de la BDD par exemple)
            projet._id = response.data.projetId;
            this.projets.unshift(projet);
            //Je crée un contrat de marché initial associé à ce projet
            let contrat = {
              agenceId: this.$store.state.auth.currentAgence._id,       // A quelle agence appartient cet élément
              projetId: projet._id,                                     // Le projet auquel il appartient
              date: Date.now(),                                         // La date de signature du contrat, par défaut la date de création du projet dans l'application
              name: "Marché initial"                                    // Le nom du contrat
            }
            this.$axios.post('contrats/register', contrat)
              .then(res =>(console.log(res.data)))
          })
          .catch(e => {
            console.log(e);
          });
      }
    },

    showModal(projet){
      this.isModalVisible = true;
      this.modalProject = projet;
    },
    closeModal(){
      this.isModalVisible = false;
      // this.modalProject = {};
    },

    clickedLink(_id){
        this.$router.push('/projet/' + _id + '/contrat/');
    },

    clickedOver(projet){
      //Passer le projet en "terminé"
      let body = {
        active: !projet.active,
      }

      this.$axios.put('projets/'+ projet._id, body)
        .then(response => {
          console.log(response.data);
          
          //Si le projet est "en cours", on le passe en "terminé", et inversement
          if(projet.active){
              projet.active = false;
              //Retirer le projet de tous les favoris utilisateurs
              this.$axios.put('users/deleteFromFavoris/'+ this.$store.state.auth.currentAgence._id + '/' + projet._id)
              .catch(err => console.log(err))

              //Supprimer le projet de la section "projets en cours" sur le client"
              let index = this.projets.findIndex(e => e._id === projet._id);
              if( index >= 0 ){
                  this.projets.splice(index, 1);
              } else {
                console.log("projet non reconnu sur le client, mais suppression effective sur le server.");
              }
              //Ajouter le projet à la section "projets terminés" du client
              this.overs.unshift(projet);

          } else {
              projet.active = true;
              //Supprimer le projet de la section "terminés" sur le client"
              let index = this.overs.findIndex(e => e._id === projet._id);
              if( index >= 0 ){
                  this.overs.splice(index, 1);
              } else {
                console.log("projet non reconnu sur le client, mais suppression effective sur le server.");
              }
              //Ajouter le projet à la section "projets en cours" du client
              this.projets.unshift(projet);
          }
        })
        .catch(err => (console.log(err)))
    },

    deleteConfirmed(projet){
      //Demander confirmation à l'utilisateur
      this.isModalVisible = true;

      //Passer le projet en "supprimé" > càd invisible mais toujours présent en BDD au cas où...
      let body = {
        deleted: true,
        active: false,
      };

      this.$axios.put('projets/'+ projet._id, body)
        .then(response => {
          console.log(response.data);
          //Supprimer le projet de l'interface client
          if(projet.active){
            let index = this.projets.findIndex(e => e._id === projet._id);
            if( index >= 0 ){
                this.projets.splice(index, 1);
            } else {
              console.log("projet non reconnu sur le client, mais suppression effective sur le server.");
            }
          } else {
            let index = this.overs.findIndex(e => e._id === projet._id);
            if( index >= 0 ){
                this.overs.splice(index, 1);
            } else {
              console.log("projet non reconnu sur le client, mais suppression effective sur le server.");
            }
          }
        })
        .catch(err => (console.log(err)))
        this.isModalVisible = false;
        // this.modalProject = {};
    },
  }
}
</script>

<template>
    <div class="main">

      <Ajouter label="Ajouter un nouveau projet" class="ajouter" text="Ajouter" @submit="addProjet($event)">
        <template v-slot:body="slotProps">
          <div class="ajouter__body">
            <input class="ajouter__body__field" type="name" placeholder="Titre" required onfocus="this.setCustomValidity('')" @keyup.enter="slotProps.submit"/>
            <input class="ajouter__body__field" type="name" placeholder="Sous-titre"  @keyup.enter="slotProps.submit"/>
          </div>
        </template>
      </Ajouter>


      <Section text="Projets en cours">
        <template v-slot:body>
          <div v-if="!projets" class="beforeLoaded">
            <Spinner />
          </div>
          <div v-else class="afterLoaded">
            <div class="afterLoaded__list">
              <div class="afterLoaded__list__item" v-for="projet in projets" :key="projet._id">
                <Card v-bind="projet"
                  v-on:clicked-link   ="clickedLink(projet._id)"
                  v-on:clicked-over   ="clickedOver(projet)"
                  v-on:clicked-delete ="showModal(projet)"
                />
                <!-- <Separatif/> -->
              </div>
            </div>
          </div>
        </template>
      </Section>
      
      
      <Section text="Projets terminés">
        <template v-slot:body>
          <div v-if="!overs" class="beforeLoaded">
            <Spinner />
          </div>
          <div v-else class="afterLoaded">
            <div class="afterLoaded__list">
              <div class="afterLoaded__list__item" v-for="over in overs" :key="over._id">
                <Card v-bind="over"
                  v-on:clicked-link   ="clickedLink(over._id)"
                  v-on:clicked-over   ="clickedOver(over)"
                  v-on:clicked-delete ="showModal(over)"
                />
                <!-- <Separatif/> -->
              </div>
            </div>
          </div>
        </template>
      </Section>

      <Modale v-show="isModalVisible" @close="closeModal">
        <template v-slot:header>
          <span>Supprimer le projet ?</span>
        </template>
        <template v-slot:body>
          <span>Êtes vous sûr de vouloir supprimer le projet {{modalProject.name}} ?</span>
        </template>
        <template v-slot:dev-notes>
          <span>Interdire la suppression si des heures ou des frais sont déjà affecté(e)s au projet. Ou alors, proposer de les affecter à un autre projet.</span>
        </template>
        <template v-slot:footer>
          <ModaleYesNo @no="closeModal" @yes="deleteConfirmed(modalProject)"></ModaleYesNo>
        </template>
      </Modale>

    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.main{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
}

.ajouter{
  margin: 0px 0 30px 0;

  &__body{
    display: flex;
   
    &__field{
      @include myFont;
      color: $black-bolder;
      margin: 5px 15px 0 0;
      width: 200px;
    }

  }
}

Section{
  width: 100%;
  margin: 0 0 20px 0;
}

.afterLoaded{
  &__list{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr)); //Pour mémoire : autant de colonnes de 400px que possible
    gap: 7px 25px; //row-gap column-gap
  }
}


</style>
